import { lazy, Suspense } from 'react';
import { useAppSelector } from 'components/editor/grid/reduxStore/Store';
import useActiveSection from 'components/editor/SectionsDrawer/useActiveSection';

const AIAssistantChatWindow = lazy(() => import('components/editor/AiAssistant/AIAssistantChatWindow'));

export default function AIAssistantWrapper({ contentId }: { contentId: string }) {
  const sections = useAppSelector((state) => state.gridBlockReducer.sections);
  const { activeSection } = useActiveSection();

  return (
    <div style={{ position: 'absolute', inset: 0, minHeight: 0 }}>
      <Suspense fallback={null}>
        <AIAssistantChatWindow contentId={contentId} sectionId={activeSection ?? sections.at(sections.length - 1)?.id ?? ''} zIndex={600} />
      </Suspense>
    </div>
  );
}
